import {
    LocalNotifications,
    PendingLocalNotificationSchema,
} from '@capacitor/local-notifications'
import { ColoursObj, Gutters, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { DateTime } from 'luxon'
import { useEffect, useState } from 'react'
import i18n from '../../../i18n/i18next'
import { useLanguageContext } from '../../../state/languageState/languageContext'
import { NavigationView } from '../../layout/NavigationView'

export function PendingNotificationsView() {
    const [pendingNotifications, setPendingNotifications] = useState<
        PendingLocalNotificationSchema[]
    >([])

    useEffect(() => {
        const getPendingNotifications = async () => {
            const pending = await LocalNotifications.getPending()
            setPendingNotifications(pending.notifications)
        }

        getPendingNotifications()
    }, [])

    function formatDate(dateToParse: number | string): string {
        try {
            const date = new Date(dateToParse)
            return DateTime.fromJSDate(date).toFormat(
                'yyyy LLL d ' + useLanguageContext.getState().timeFormat,
                {
                    locale: useLanguageContext
                        .getState()
                        .getLanguageISO639Code(),
                }
            )
        } catch (error) {
            console.log(error)
            return ''
        }
    }

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.pending')}
            backButtonAction={() => {
                window.pushPath('/account/local-notifications')
            }}
            usePageTransition
        >
            <Gutters>
                <Stack gap="16px">
                    {pendingNotifications.length > 0 &&
                        pendingNotifications
                            .sort(
                                (a, b) =>
                                    (b.schedule?.at?.valueOf() ?? 0) -
                                    (a.schedule?.at?.valueOf() ?? 0)
                            )
                            .map((notification) => (
                                <Stack key={notification.id}>
                                    <Typography variant="bodyBold">
                                        {notification.title}
                                    </Typography>

                                    <Typography variant="bodyRegular">
                                        {notification.body}
                                    </Typography>

                                    <Typography
                                        variant="bodySubtext"
                                        color={ColoursObj.font.secondary}
                                    >
                                        {notification.schedule?.at?.valueOf() &&
                                            formatDate(
                                                notification.schedule?.at?.valueOf()
                                            )}
                                    </Typography>
                                </Stack>
                            ))}
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
